import moment from 'moment';
import { tour_status } from '../../enums/tour-status';

const computeTourSubtitle = (features, tour) => {
  let tourSubtitleParts = [];

  if (
    features?.OTHERS?.BACKOFFICE?.tourNumberOnlyLastDigit &&
    tour?.tour_number
  ) {
    tourSubtitleParts.push(`Tournée ${tour.tour_number}`);
  } else if (tour?.vehicule_key) {
    tourSubtitleParts.push(`Véhicule ${tour.vehicule_key}`);
  }

  if (tour?.fullname || tour?.driver?.fullname) {
    tourSubtitleParts.push(
      `Chauffeur ${tour.fullname || tour.driver.fullname}`
    );
  }

  if (features?.OTHERS?.UPLOAD?.tourCreationDateUsed && tour?.creation_date) {
    const creationDateParsed = moment(tour.creation_date).format('HH[h]mm');

    if (tour?.client_id === 5) {
      tourSubtitleParts.push(`Chargée à ${creationDateParsed}`);
    } else {
      tourSubtitleParts.push(`Intégrée à ${creationDateParsed}`);
    }
  } else if (tour?.status !== tour_status.IMPORTED && tour?.starting_date) {
    const startingDateParsed = moment(tour.starting_date).format('HH[h]mm');
    tourSubtitleParts.push(`Départ à ${startingDateParsed}`);
  } else if (tour?.starting_date) {
    tourSubtitleParts.push(`Départ non saisi`);
  }

  if (tour?.additional_datas?.cleaning_mandatory === 1) {
    tourSubtitleParts.push(`Nettoyage obligatoire`);
  }

  if (tour?.additional_datas?.key_mandatory === 1) {
    tourSubtitleParts.push(`Clé nécessaire pour la livraison`);
  }

  return tourSubtitleParts?.join(' • ');
};

export default computeTourSubtitle;
